<div class="feature feature-1">
  <img alt="Image" [src]="(data?.img?.url | fsoImageOptimizer)" />
  <div class="feature__body boxed boxed--border">
    <h4 *ngIf="data?.name">{{ data?.name }}</h4>
    <p *ngIf="data?.description">{{ data?.description }}</p>
    <!-- <a href="#"> Learn More </a> -->
  </div>
</div>
